import KycDetails from "./KycDetails";
export default KycDetails;
